import LocationIcon from "@components/icons/LocationIcon"
import { isEmpty } from "lodash"
import React, { useEffect } from "react"
import loadable from "@loadable/component"
import {
  AllSelectedAreas,
  SelectedFirstArea,
} from "../PredictiveSearch/SelectedAreaList"
import useAreaMultiSelect from "../PredictiveSearch/useAreaMutiSelect"
import "./MultiSelectInput.scss"
import SearchIcon from "@components/icons/SearchIcon"
import useDeviceMedia from "@hooks/useDeviceMedia"
import { useMediaQuery } from "@hooks/useMediaQuery"
import SearchFuzzy from "../PredictiveSearch/SearchFuzzy"

// const SearchFuzzy = loadable(() => import("../PredictiveSearch/SearchFuzzy"))

const MultiSelectInput = ({ isOffPlan, setIsModalOpen, isOnclick}) => {
  const {
    searchText,
    setSearchText,
    areasSuggestionList,
    handleSelectArea,
    setSearchSlug,
    selectedAreas,
    showSearchInput,
    setShowSearchInput,
    handleRemoveArea,
    handleRemoveAreas,
    handleRemoveAllAreas,
  } = useAreaMultiSelect({
    isOffPlan,
  })
  // const {
  //   isMobile
  // } = useDeviceMedia()
  useEffect(() => {
    const multiSelectInput = document.getElementById("multi-select-input")
    const firstAreaField = document.getElementById("first-selected-area-field")
    const suggestionBox = document.getElementById("react-autowhatever-1")
    // const addButton = document.getElementById("add-button")

    const listener = (event) => {
      if (
        event.target.id === "add-button" ||
        !selectedAreas.length ||
        suggestionBox?.contains(event.target) ||
        event.target?.parentElement?.className?.includes?.("autosuggest") ||
        event.target?.id === "more-areas-button" ||
        (showSearchInput &&
          event.target?.className?.baseVal?.includes?.("close-icon"))
      ) {
        setShowSearchInput(true)
        return
      }
      // setshowsearchinput to false if click outside of multiSelectInput or firstAreaField when showSearchInput is true
      if (
        showSearchInput &&
        !!selectedAreas.length &&
        !multiSelectInput.contains(event.target) &&
        !firstAreaField?.contains(event.target)
      ) {
        setShowSearchInput(false)
      }
    }

    window.addEventListener("click", listener)

    return () => {
      window.removeEventListener("click", listener)
    }
  }, [showSearchInput, selectedAreas, setShowSearchInput])

  return (
    <div className="mutil-select-wrap" onClick={isOnclick && useMediaQuery("(max-width: 743px)") ? () => setIsModalOpen(true) : null}>
      {showSearchInput || isEmpty(selectedAreas) ? (
        <div className="multi-select-input" id="multi-select-input">
          <div className="filter search-box">
            <SearchIcon />
            <SearchFuzzy
              placeholder="Area, project or community"
              handleSelectArea={handleSelectArea}
              searchText={searchText}
              setSearchText={setSearchText}
              areasSuggestionList={areasSuggestionList}
              setSearchSlug={setSearchSlug}
            />
          </div>
          {selectedAreas.length > 0 && (
            <AllSelectedAreas
              handleRemoveArea={handleRemoveArea}
              selectedAreas={selectedAreas}
            />
          )}
        </div>
      ) : (
        <SelectedFirstArea
          selectedAreas={selectedAreas}
          setShowSearchInput={setShowSearchInput}
          handleRemoveArea={handleRemoveArea}
          handleRemoveAreas={handleRemoveAreas}
          handleRemoveAllAreas={handleRemoveAllAreas}
        />
      )}
    </div>
  )
}

export default MultiSelectInput
